export default __webpack_public_path__ + "static/media/partner.a101bbbe.png";